import { useCallback, useMemo } from 'react';

import { BodyAreaType, RelatedGuidesContentType } from '../../containers/app/landingPages/@types/landingPages';
import {
  relatedGuidesNames,
  sectionNames,
} from '../../containers/app/landingPages/Pages/LandingPage.helpers';

export type FilterComponentsType = {
  acf: {
    [key: string]: string;
  };
  components: {
    description: string;
    thumbnail: string;
    title: string;
    url: string;
  }[];
};

export const useLandingPageSections = (acf?: Record<string, unknown> | null) => {
  const processRelatedGuides = useCallback((acfData?: Record<string, unknown> | null) => {
    if (!acfData) {
      return [];
    }

    return relatedGuidesNames
      .filter((component) => acfData[component.title])
      .map(
        ({ description, thumbnail, title, url }) => ({
          description: acfData[description],
          thumbnail: acfData[thumbnail],
          title: acfData[title],
          url: acfData[url] || '',
        }),
      ) as RelatedGuidesContentType;
  }, []);

  const bodyAreaSections = useMemo(() => {
    if (!acf) {
      return [];
    }

    return sectionNames
      .filter((section) => acf[section.title])
      .map(({ contentBody, imageAlt, imageArea, position, theme, title }) => ({
        contentBody: acf[contentBody],
        imgAlt: acf[imageAlt],
        imgSrc: acf[imageArea],
        position,
        theme,
        title: acf[title],
      })) as BodyAreaType;
  }, [acf]);

  return {
    bodyAreaSections,
    processRelatedGuides,
  };
};
